/**
 * view.js — no frontend JavaScript needed for this block.
 *
 * This file is intentionally minimal. The block renders as a plain HTML
 * anchor or div from render.php and requires no client-side scripting.
 *
 * If you add interactive behavior later (e.g. lightbox, scroll effects),
 * implement it here and register it via the `viewScript` field in block.json.
 */
